module.exports = __webpack_public_path__ + "img/UI_common_framelabelBD_01_df7ea0421.png";